import { QRCodeModule } from "angularx-qrcode";
import { NgxMaskModule } from 'ngx-mask';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ManifestDirectiveModule } from '@pages/manifests/directives/directive.module';

import { components } from './components/index';
import { directives } from './directives/index';
import { pipes } from './pipes/index';
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatInputModule } from "@angular/material/input";

@NgModule({
	imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, ManifestDirectiveModule, MatIconModule, MatInputModule, MatSelectModule, QRCodeModule, NgxMaskModule.forRoot()],
	exports: [...components, ...pipes, ...directives],
	declarations: [...components, ...pipes, ...directives],
	providers: [],
})
export class SharedModule {}
